export const allRegions = {
  India: {
    "Andaman and Nicobar Islands": ["Port Blair"],
    "Andhra Pradesh": [
      "Addanki",
      "Akividu",
      "Akkarampalle",
      "Amalapuram",
      "Amudalavalasa",
      "Anakapalle",
      "Anantapur",
      "Atmakur",
      "Attili",
      "Avanigadda",
      "Badvel",
      "Banganapalle",
      "Betamcherla",
      "Bhattiprolu",
      "Bhimavaram",
      "Bhimunipatnam",
      "Bobbili",
      "Bapatla",
      "Challapalle",
      "Chemmumiahpet",
      "Chicacole",
      "Chilakalurupet",
      "Chinnachowk",
      "Chodavaram",
      "Chipurupalle",
      "Chirala",
      "Cuddapah",
      "Cumbum",
      "Dharmavaram",
      "Dhone",
      "Elamanchili",
      "Ellore",
      "Emmiganur",
      "Erraguntla",
      "Gajuwaka",
      "Gannavaram",
      "Giddalur",
      "Gudivada",
      "Guntakal Junction",
      "Guntur",
      "Gudur",
      "Hindupur",
      "Ichchapuram",
      "Jaggayyapeta",
      "Jammalamadugu",
      "Kadiri",
      "Kaikalur",
      "Kalyandurg",
      "Kandukur",
      "Kanigiri",
      "Kanuru",
      "Kondapalle",
      "Kosigi",
      "Kovvur",
      "Kovur",
      "Kuppam",
      "Kakinada",
      "Kavali",
      "Machilipatnam",
      "Madanapalle",
      "Mandapeta",
      "Mangalagiri",
      "Macherla",
      "Markapur",
      "Nagari",
      "Nandigama",
      "Nandikotkur",
      "Nandyal",
      "Narasannapeta",
      "Narasapur",
      "Narasaraopet",
      "Narsipatnam",
      "Nellore",
      "Nidadavole",
      "Nayudupeta",
      "Nuzvid",
      "Ongole",
      "Palmaner",
      "Palasa",
      "Parlakimidi",
      "Pedana",
      "Peddapuram",
      "Penugonda",
      "Penukonda",
      "Phirangipuram",
      "Pithapuram",
      "Polavaram",
      "Ponnur",
      "Ponnuru",
      "Proddatur",
      "Pulivendla",
      "Punganuru",
      "Puttur",
      "Pakala",
      "Palakollu",
      "Palkonda",
      "Parvatipuram",
      "Ramanayyapeta",
      "Rampachodavaram",
      "Renigunta",
      "Repalle",
      "Rajahmundry",
      "Rajampet",
      "Ramachandrapuram",
      "Ramapuram",
      "Rayachoti",
      "Rayadrug",
      "Razam",
      "Sattenapalle",
      "Singarayakonda",
      "Sompeta",
      "Srisailain",
      "Salur",
      "Samalkot",
      "Suluru",
      "Tanuku",
      "Tekkali",
      "Tirumala",
      "Tirupati",
      "Tuni",
      "Tadepalle",
      "Tadepallegudem",
      "Tadpatri",
      "Uravakonda",
      "Vadlapudi",
      "Venkatagiri",
      "Vepagunta",
      "Vetapalem",
      "Vijayawada",
      "Vinukonda",
      "Visakhapatnam",
      "Vizianagaram",
      "Vuyyuru",
      "Yanam",
      "Yanamalakuduru",
      "Adoni",
    ],
    "Arunachal Pradesh": [
      "Along",
      "Itanagar",
      "Margherita",
      "Naharlagun",
      "Pasighat",
    ],
    Assam: [
      "Abhayapuri",
      "Barpeta",
      "Barpeta Road",
      "Bilasipara",
      "Bokajan",
      "Bongaigaon",
      "Chapar",
      "Dhekiajuli",
      "Dhing",
      "Dhuburi",
      "Dibrugarh",
      "Digboi",
      "Diphu",
      "Duliagaon",
      "Dum Duma",
      "Gauripur",
      "Golaghat",
      "Goalpara",
      "Guwahati",
      "Hailakandi",
      "Hojai",
      "Howli",
      "Haflong",
      "Hajo",
      "Jorhat",
      "Karimganj",
      "Kharupatia",
      "Kokrajhar",
      "Lumding Railway Colony",
      "Mangaldai",
      "Marigaon",
      "Mariani",
      "Makum",
      "Nahorkatiya",
      "North Guwahati",
      "North Lakhimpur",
      "Namrup",
      "Rangia",
      "Rangapara",
      "Sibsagar",
      "Silapathar",
      "Silchar",
      "Sonari",
      "Tezpur",
      "Tinsukia",
      "Udalguri",
    ],
    Bihar: [
      "Amarpur",
      "Arrah",
      "Araria",
      "Aurangabad",
      "Bagaha",
      "Bahadurganj",
      "Bairagnia",
      "Bakhtiyarpur",
      "Bangaon",
      "Banmankhi",
      "Bar Bigha",
      "Barauli",
      "Barhiya",
      "Begusarai",
      "Belsand",
      "Bettiah",
      "Bhabhua",
      "Bhawanipur",
      "Bhagalpur",
      "Bihar",
      "Bihariganj",
      "Bikramganj",
      "Buddh Gaya",
      "Buxar",
      "Banka",
      "Barh",
      "Baruni",
      "Birpur",
      "Chhatapur",
      "Chakia",
      "Chapra",
      "Colgong",
      "Dalsingh Sarai",
      "Darbhanga",
      "Daudnagar",
      "Dehri",
      "Dhaka",
      "Dighwara",
      "Dinapore",
      "Dumra",
      "Dumraon",
      "Fatwa",
      "Forbesganj",
      "Gaya",
      "Gopalganj",
      "Hilsa",
      "Hisua",
      "Hajipur",
      "Islampur",
      "Jagdispur",
      "Jahanabad",
      "Jamalpur",
      "Jamui",
      "Jaynagar",
      "Jhanjharpur",
      "Jha Jha",
      "Jogbani",
      "Kasba",
      "Katihar",
      "Khagaria",
      "Khagaul",
      "Kharagpur",
      "Kishanganj",
      "Koelwar",
      "Koath",
      "Luckeesarai",
      "Lalganj",
      "Madhipura",
      "Madhubani",
      "Maharajgani",
      "Mairwa",
      "Maner",
      "Manihari",
      "Marhaura",
      "Masaurhi Buzurg",
      "Mokameh",
      "Monghyr",
      "Mothihari",
      "Murliganj",
      "Muzaffarpur",
      "Nabinagar",
      "Naugachhia",
      "Nawada",
      "Nirmali",
      "Nasriganj",
      "Patna",
      "Piro",
      "Pupri",
      "Purnia",
      "Rafiganj",
      "Raxaul",
      "Revelganj",
      "Rusera",
      "Rajgir",
      "Ramnagar",
      "Sagauli",
      "Saharsa",
      "Samastipur",
      "Shahbazpur",
      "Sheikhpura",
      "Sheohar",
      "Sherghati",
      "Shahpur",
      "Silao",
      "Siwan",
      "Supaul",
      "Sitamarhi",
      "Teghra",
      "Tekari",
      "Thakurganj",
      "Waris Aliganj",
    ],
    Chandigarh: ["Chandigarh"],
    Chhattisgarh: [
      "Akaltara",
      "Ambikapur",
      "Arang",
      "Balod",
      "Baloda Bazar",
      "Bemetara",
      "Bhilai",
      "Bhanpuri",
      "Bhatapara",
      "Bilaspur",
      "Champa",
      "Dhamtari",
      "Dongargarh",
      "Durg",
      "Gumla",
      "Jagdalpur",
      "Jashpurnagar",
      "Janjgir",
      "Junagarh",
      "Katghora",
      "Kawardha",
      "Khairagarh",
      "Kharsia",
      "Kirandul",
      "Kondagaon",
      "Korba",
      "Kotaparh",
      "Kota",
      "Kumhari",
      "Kanker",
      "Mahasamund",
      "Mungeli",
      "Pasan",
      "Pathalgaon",
      "Raigarh",
      "Raipur",
      "Ratanpur",
      "Raj-Nandgaon",
      "Sakti",
      "Saraipali",
      "Takhatpur",
      "Umarkot",
    ],
    "Dadra and Nagar Haveli": ["Silvassa", "Amli"],
    "Daman and Diu": ["Daman", "Diu"],
    Goa: [
      "Calangute",
      "Cuncolim",
      "Curchorem",
      "Dicholi",
      "Madgaon",
      "Marmagao",
      "Mapuca",
      "Panaji",
      "Ponda",
      "Sancoale",
      "Taleigao",
      "Vasco Da Gama",
      "Goa",
    ],
    Gujarat: [
      "Ahmedabad",
      "Amod",
      "Amreli",
      "Amroli",
      "Anjar",
      "Ankleshwar",
      "Bagasra",
      "Bedi",
      "Bhachau",
      "Bharuch",
      "Bhuj",
      "Bhanvad",
      "Bhavnagar",
      "Bhayavadar",
      "Bilimora",
      "Borsad",
      "Botad",
      "Babra",
      "Bantva",
      "Bardoli",
      "Chaklasi",
      "Chalala",
      "Chhala",
      "Chhota Udepur",
      "Chotila",
      "Chanasma",
      "Dabhoi",
      "Dahegam",
      "Devgadh Bariya",
      "Dhandhuka",
      "Dhanera",
      "Dharampur",
      "Dholka",
      "Dhoraji",
      "Dhrol",
      "Dhrangadhra",
      "Dhari",
      "Dohad",
      "Dwarka",
      "Dakor",
      "Damnagar",
      "Disa",
      "Gadhada",
      "Gandevi",
      "Gariadhar",
      "Ghandinagar",
      "Godhra",
      "Gondal",
      "Gandhidham",
      "Halvad",
      "Himatnagar",
      "Halol",
      "Harij",
      "Jalalpur",
      "Jambusar",
      "Jasdan",
      "Jetpur",
      "Jodhpur",
      "Jodiya Bandar",
      "Jamnagar",
      "Junagadh",
      "Kadi",
      "Kadod",
      "Kapadvanj",
      "Karamsad",
      "Keshod",
      "Khambhaliya",
      "Khambhat",
      "Khed Brahma",
      "Kheda",
      "Kheralu",
      "Kodinar",
      "Kosamba",
      "Kundla",
      "Kutiyana",
      "Kalol",
      "Kalavad",
      "Kandla",
      "Kathor",
      "Limbdi",
      "Lalpur",
      "Lathi",
      "Lunavada",
      "Mahemdavad",
      "Mahudha",
      "Mendarda",
      "Modasa",
      "Morbi",
      "Morwa",
      "Mundra",
      "Mandvi",
      "Mangrol",
      "Mansa",
      "Manavadar",
      "Nadiad",
      "Okha",
      "Padra",
      "Petlad",
      "Porbandar",
      "Palanpur",
      "Palitana",
      "Pardi",
      "Patan",
      "Radhanpur",
      "Rajkot",
      "Rajpipla",
      "Rajula",
      "Ranavav",
      "Rapar",
      "Salaya",
      "Sarkhej",
      "Siddhapur",
      "Sihor",
      "Sikka",
      "Sojitra",
      "Songadh",
      "Surendranagar",
      "Sanand",
      "Sayla",
      "Surat",
      "Talaja",
      "Tharad",
      "Than",
      "Thasra",
      "Umreth",
      "Un",
      "Una",
      "Unjha",
      "Upleta",
      "Vadnagar",
      "Vadodara",
      "Valabhipur",
      "Vallabh Vidyanagar",
      "Valsad",
      "Vapi",
      "Vasa",
      "Vejalpur",
      "Veraval",
      "Vijapur",
      "Visnagar",
      "Vyara",
      "Visavadar",
      "Wankaner",
      "Anand",
    ],
    Haryana: [
      "Ambala",
      "Bahadurgarh",
      "Bara Uchana",
      "Barwala",
      "Beri Khas",
      "Bhiwani",
      "Charkhi Dadri",
      "Dabwali",
      "Dharuhera",
      "Ellenabad",
      "Faridabad",
      "Fatehabad",
      "Firozpur Jhirka",
      "Gharaunda",
      "Gohana",
      "Gorakhpur",
      "Gurgaon",
      "Hisar",
      "Hodal",
      "Hansi",
      "Indri",
      "Jagadhri",
      "Jhajjar",
      "Jind",
      "Kaithal",
      "Kalanaur",
      "Karnal",
      "Kharkhauda",
      "Kalanwali",
      "Kurukshetra",
      "Ladwa",
      "Maham",
      "Mahendragarh",
      "Narwana",
      "Narayangarh",
      "Narnaul",
      "Narnaund",
      "Nilokheri",
      "Palwal",
      "Pataudi",
      "Pehowa",
      "Pinjaur",
      "Panipat",
      "Pundri",
      "Punahana",
      "Ratia",
      "Rewari",
      "Rohtak",
      "Rania",
      "Safidon",
      "Samalkha",
      "Shahabad",
      "Sirsa",
      "Sohna",
      "Sonipat",
      "Thanesar",
      "Tohana",
      "Taoru",
      "Yamunanagar",
      "Asandh",
    ],
    "Himachal Pradesh": [
      "Baddi",
      "Chamba",
      "Dharmsala",
      "Hamirpur",
      "Kulu",
      "Kalka",
      "Mandi",
      "Nahan",
      "Paonta Sahib",
      "Shimla",
      "Solan",
      "Sundarnagar",
      "Una",
    ],
    Jharkhand: [
      "Barka Kana",
      "Barki Saria",
      "Bokaro",
      "Bundu",
      "Chakradharpur",
      "Chatra",
      "Chas",
      "Chaibasa",
      "Daltonganj",
      "Dhanbad",
      "Dugda",
      "Dumka",
      "Garhwa",
      "Ghatsila",
      "Giridih",
      "Gobindpur",
      "Godda",
      "Gomoh",
      "Gumia",
      "Hazaribag",
      "Husainabad",
      "Jamshedpur",
      "Jasidih",
      "Jharia",
      "Jugsalai",
      "Jumri Tilaiya",
      "Jamadoba",
      "Jamtara",
      "Khunti",
      "Kodarma",
      "Kuju",
      "Kanke",
      "Katras",
      "Lohardaga",
      "Latehar",
      "Madhupur",
      "Mushabani",
      "Noamundi",
      "Pakaur",
      "Pathardih",
      "Ranchi",
      "Ramgarh",
      "Sijua",
      "Simdega",
      "Sahibganj",
    ],
    Karnataka: [
      "Afzalpur",
      "Aland",
      "Alnavar",
      "Anekal",
      "Annigeri",
      "Arkalgud",
      "Arsikere",
      "Athni",
      "Aurad",
      "Bagalkot",
      "Bail-Hongal",
      "Bangarapet",
      "Bannur",
      "Bantval",
      "Basavakalyan",
      "Basavana Bagevadi",
      "Belgaum",
      "Bellary",
      "Belur",
      "Bengaluru",
      "Bhadravati",
      "Bhatkal",
      "Bhalki",
      "Bijapur",
      "Bilgi",
      "Birur",
      "Byndoor",
      "Byadgi",
      "Badami",
      "Bagepalli",
      "Bidar",
      "Challakere",
      "Chamrajnagar",
      "Channagiri",
      "Channapatna",
      "Channarayapatna",
      "Chik Ballapur",
      "Chikmagalur",
      "Chiknayakanhalli",
      "Chikodi",
      "Chincholi",
      "Chintamani",
      "Chitradurga",
      "Chitapur",
      "Coondapoor",
      "Dandeli",
      "Devanhalli",
      "Dod Ballapur",
      "French Rocks",
      "Gadag",
      "Gajendragarh",
      "Gangolli",
      "Gangawati",
      "Gokak",
      "Gokarna",
      "Goribidnur",
      "Gubbi",
      "Gulbarga",
      "Guledagudda",
      "Gundlupet",
      "Gurmatkal",
      "Hadagalli",
      "Haliyal",
      "Harihar",
      "Harpanahalli",
      "Hassan",
      "Hirekerur",
      "Hiriyur",
      "Holalkere",
      "Hole Narsipur",
      "Homnabad",
      "Honnali",
      "Honavar",
      "Hosdurga",
      "Hoskote",
      "Hospet",
      "Hubli",
      "Hukeri",
      "Hungund",
      "Hunsur",
      "Hangal",
      "Haveri",
      "Ilkal",
      "Indi",
      "Jagalur",
      "Jamkhandi",
      "Jevargi",
      "Kadur",
      "Kalghatgi",
      "Kampli",
      "Kanakapura",
      "Karwar",
      "Kerur",
      "Khanapur",
      "Kollegal",
      "Kolar",
      "Konnur",
      "Koppal",
      "Kotturu",
      "Krishnarajpet",
      "Kudachi",
      "Kumta",
      "Kundgol",
      "Kunigal",
      "Kushtagi",
      "Karkala",
      "Kudligi",
      "Lakshmeshwar",
      "Lingsugur",
      "Maddagiri",
      "Maddur",
      "Madikeri",
      "Mahalingpur",
      "Malavalli",
      "Malpe",
      "Mandya",
      "Mangalore",
      "Muddebihal",
      "Mudgal",
      "Mudhol",
      "Mulbagal",
      "Mulgund",
      "Mundargi",
      "Mundgod",
      "Murudeshwara",
      "Mysore",
      "Magadi",
      "Malur",
      "Manvi",
      "Mudbidri",
      "Mulki",
      "Nanjangud",
      "Naregal",
      "Nargund",
      "Navalgund",
      "Nelamangala",
      "Nagamangala",
      "Piriyapatna",
      "Puttur",
      "Pavugada",
      "Rabkavi",
      "Robertsonpet",
      "Ron",
      "Raichur",
      "Ramanagaram",
      "Ranibennur",
      "Raybag",
      "Sadalgi",
      "Sakleshpur",
      "Sandur",
      "Sankeshwar",
      "Saundatti",
      "Savanur",
      "Seram",
      "Shiggaon",
      "Shikarpur",
      "Shimoga",
      "Shirhatti",
      "Shorapur",
      "Shrirangapattana",
      "Shahpur",
      "Shahabad",
      "Sidlaghatta",
      "Sindgi",
      "Sindhnur",
      "Sirsi",
      "Siruguppa",
      "Someshwar",
      "Srinivaspur",
      "Sulya",
      "Sagar",
      "Sira",
      "Tarikere",
      "Tekkalakote",
      "Terdal",
      "Tiptur",
      "Tumkur",
      "Talikota",
      "Tirthahalli",
      "Udipi",
      "Ullal",
      "Vijayapura",
      "Virarajendrapet",
      "Wadi",
      "Yelahanka",
      "Yellapur",
      "Yadgir",
    ],
    Kashmir: [
      "Anantnag",
      "Bandipura",
      "Bijbiara",
      "Baramula",
      "Doda",
      "Gandarbal",
      "Jammu",
      "Kathua",
      "Kishtwar",
      "Kulgam",
      "Leh",
      "Padam",
      "Pulwama",
      "Punch",
      "Rajaori",
      "Sopur",
      "Soyibug",
      "Srinagar",
      "Samba",
      "Udhampur",
    ],
    Kerala: [
      "Adur",
      "Alleppey",
      "Aluva",
      "Angamali",
      "Aroor",
      "Arukutti",
      "Attingal",
      "Badagara",
      "Beypore",
      "Cannanore",
      "Changanacheri",
      "Chengannur",
      "Cherpulassery",
      "Cherthala",
      "Chittur",
      "Chavakkad",
      "Cochin",
      "Dharmadam",
      "Elur",
      "Erattupetta",
      "Ferokh",
      "Guruvayur",
      "Iringal",
      "Irinjalakuda",
      "Kadakkavoor",
      "Kalamassery",
      "Kalavoor",
      "Kalpetta",
      "Kattanam",
      "Kizhake Chalakudi",
      "Kodungallur",
      "Kollam",
      "Kotamangalam",
      "Kottayam",
      "Kozhikode",
      "Kumbalam",
      "Kunnamangalam",
      "Kunnamkulam",
      "Kutiatodu",
      "Kuttampuzha",
      "Kannangad",
      "Kasaragod",
      "Kayankulam",
      "Mahe",
      "Malappuram",
      "Manjeri",
      "Mannarakkat",
      "Mattanur",
      "Mavoor",
      "Muluppilagadu",
      "Munnar",
      "Muvattupuzha",
      "Mavelikara",
      "Muvattupula",
      "Naduvannur",
      "Nedumangad",
      "Neyyattinkara",
      "Nadapuram",
      "Nileshwar",
      "Ottappalam",
      "Palakkad",
      "Panmana",
      "Paravur",
      "Pariyapuram",
      "Pathanamthitta",
      "Payyannur",
      "Perumbavoor",
      "Perumpavur",
      "Piravam",
      "Ponnani",
      "Punalur",
      "Pappinissheri",
      "Shertallai",
      "Shoranur",
      "Talipparamba",
      "Tellicherry",
      "Thiruvananthapuram",
      "Tirur",
      "Tiruvalla",
      "Trichur",
      "Vaikam",
      "Varkala",
      "Vayalar",
      "Vettur",
    ],
    "Madhya Pradesh": [
      "Agar",
      "Alot",
      "Amarpatan",
      "Ambah",
      "Amla",
      "Anjad",
      "Anuppur",
      "Ashoknagar",
      "Ashta",
      "Badnawar",
      "Baihar",
      "Banda",
      "Bargi",
      "Barwani",
      "Begamganj",
      "Beohari",
      "Berasia",
      "Betul",
      "Bhainsdehi",
      "Bhawaniganj",
      "Bhikangaon",
      "Bhind",
      "Bhitarwar",
      "Bhopal",
      "Bhander",
      "Bhanpura",
      "Biaora",
      "Bijawar",
      "Burhar",
      "Burhanpur",
      "Babai",
      "Balaghat",
      "Bamor Kalan",
      "Basoda",
      "Chanderi",
      "Chhatarpur",
      "Chhindwara",
      "Daboh",
      "Dabra",
      "Damoh",
      "Datia",
      "Deori Khas",
      "Depalpur",
      "Dewas",
      "Dhamnod",
      "Dhar",
      "Dindori",
      "Etawa",
      "Garhakota",
      "Gohadi",
      "Guna",
      "Gwalior",
      "Gadarwara",
      "Harda Khas",
      "Harpalpur",
      "Harsud",
      "Hatta",
      "Hindoria",
      "Hoshangabad",
      "Indore",
      "Itarsi",
      "Jabalpur",
      "Jaora",
      "Jatara",
      "Jhabua",
      "Jora",
      "Jamai",
      "Jawad",
      "Kailaras",
      "Kaimori",
      "Kannod",
      "Kareli",
      "Karera",
      "Kasrawad",
      "Katangi",
      "Khajuraho",
      "Khamaria",
      "Khandwa",
      "Khargone",
      "Khilchipur",
      "Khirkiyan",
      "Khurai",
      "Khachrod",
      "Khategaon",
      "Kolaras",
      "Korwai",
      "Kotma",
      "Kukshi",
      "Kumbhraj",
      "Lahar",
      "Lakhnadon",
      "Leteri",
      "Maheshwar",
      "Mahgawan",
      "Maihar",
      "Maksi",
      "Mandideep",
      "Mandla",
      "Mandsaur",
      "Manasa",
      "Manawar",
      "Mau",
      "Mauganj",
      "Mihona",
      "Morena",
      "Morar",
      "Multai",
      "Mungaoli",
      "Murwara",
      "Mandu",
      "Nagda",
      "Nainpur",
      "Naraini",
      "Narsimhapur",
      "Narsinghgarh",
      "Narwar",
      "Nasrullahganj",
      "Nepanagar",
      "Nagod",
      "Palera",
      "Panna",
      "Panagar",
      "Parasia",
      "Patharia",
      "Pithampur",
      "Porsa",
      "Punasa",
      "Pali",
      "Pandhurna",
      "Raisen",
      "Rajpur",
      "Ratlam",
      "Rehli",
      "Rewa",
      "Raghogarh",
      "Rahatgarh",
      "Rajgarh",
      "Rampura",
      "Sabalgarh",
      "Sanawad",
      "Satna",
      "Saugor",
      "Sausar",
      "Sehore",
      "Sendhwa",
      "Seondha",
      "Seoni",
      "Seoni Malwa",
      "Shahdol",
      "Sheopur",
      "Shivpuri",
      "Shujalpur",
      "Shahpur",
      "Shajapur",
      "Shamgarh",
      "Sidhi",
      "Sihora",
      "Singrauli",
      "Sironj",
      "Sohagpur",
      "Sarangpur",
      "Tarana",
      "Teonthar",
      "Tikamgarh",
      "Udaipura",
      "Ujjain",
      "Umaria",
      "Unhel",
      "Vidisha",
      "Waraseoni",
      "Aron",
    ],
    Maharashtra: [
      "Achalpur",
      "Ahmadnagar",
      "Ahmadpur",
      "Airoli",
      "Ajra",
      "Akalkot",
      "Akola",
      "Akot",
      "Alandi",
      "Alibag",
      "Amalner",
      "Amarnath",
      "Ambad",
      "Ambajogai",
      "Amravati",
      "Anjangaon",
      "Anshing",
      "Ashta",
      "Aurangabad",
      "Ausa",
      "Badlapur",
      "Ballalpur",
      "Basmat",
      "Bhandara",
      "Bhayandar",
      "Bhiwandi",
      "Bhor",
      "Bhudgaon",
      "Bhusaval",
      "Bhum",
      "Boisar",
      "Borivli",
      "Buldana",
      "Balapur",
      "Barsi",
      "Baramati",
      "Chicholi",
      "Chikhli",
      "Chiplun",
      "Chopda",
      "Chakan",
      "Chalisgaon",
      "Chanda",
      "Chandor",
      "Chandur",
      "Chandur",
      "Chandur Bazar",
      "Daryapur",
      "Dattapur",
      "Daund",
      "Deoli",
      "Deolali",
      "Deulgaon Raja",
      "Dharangaon",
      "Dharmabad",
      "Dharur",
      "Dhulia",
      "Digras",
      "Dombivli",
      "Dondaicha",
      "Durgapur",
      "Dahanu",
      "Darwha",
      "Diglur",
      "Erandol",
      "Faizpur",
      "Gadhinglaj",
      "Gangakher",
      "Gangapur",
      "Gevrai",
      "Ghoti Budrukh",
      "Ghugus",
      "Ghatanji",
      "Gondia",
      "Hadgaon",
      "Hinganghat",
      "Hingoli",
      "Ichalkaranji",
      "Igatpuri",
      "Indapur",
      "Jaisingpur",
      "Jalgaon",
      "Jalgaon Jamod",
      "Jintur",
      "Junnar",
      "Jalna",
      "Kalamb",
      "Kalamnuri",
      "Kalmeshwar",
      "Kalyan",
      "Kankauli",
      "Kannad",
      "Karjat",
      "Karmala",
      "Karad",
      "Khadki",
      "Kharakvasla",
      "Khetia",
      "Khopoli",
      "Khuldabad",
      "Khamgaon",
      "Khapa",
      "Kinwat",
      "Kodoli",
      "Kolhapur",
      "Kopargaon",
      "Koregaon",
      "Koynanagar",
      "Kurandvad",
      "Kurduvadi",
      "Kagal",
      "Kamthi",
      "Karanja",
      "Katol",
      "Latur",
      "Lonavala",
      "Lonar",
      "Mahad",
      "Malkapur",
      "Mangrul Pir",
      "Manmad",
      "Mehekar",
      "Mhasvad",
      "Moram",
      "Morsi",
      "Mudkhed",
      "Mukher",
      "Mumbai",
      "Murbad",
      "Murtajapur",
      "Majalgaon",
      "Malegaon",
      "Malvan",
      "Manwat",
      "Mul",
      "Nagpur",
      "Naldurg",
      "Nanded",
      "Nandurbar",
      "Nashik",
      "Navi Mumbai",
      "Neral",
      "Nilanga",
      "Nipani",
      "Nandgaon",
      "Nandura Buzurg",
      "Osmanabad",
      "Ozar",
      "Paithan",
      "Pandharpur",
      "Panvel",
      "Parbhani",
      "Parli Vaijnath",
      "Parola",
      "Partur",
      "Pawni",
      "Pen",
      "Phaltan",
      "Pimpri",
      "Powai",
      "Pulgaon",
      "Pune",
      "Pusad",
      "Pachora",
      "Palghar",
      "Pathardi",
      "Pathri",
      "Patur",
      "Pipri",
      "Purna",
      "Rahimatpur",
      "Ratnagiri",
      "Risod",
      "Roha",
      "Rahuri",
      "Rajgurunagar",
      "Rajura",
      "Ramtek",
      "Raver",
      "Sangamner",
      "Saoner",
      "Satana",
      "Selu",
      "Shegaon",
      "Shiraguppi",
      "Shirdi",
      "Shirpur",
      "Shivaji Nagar",
      "Shrigonda",
      "Shahada",
      "Sillod",
      "Sinnar",
      "Sirur",
      "Solapur",
      "Soygaon",
      "Srivardhan",
      "Sangli",
      "Sangola",
      "Sasvad",
      "Satara",
      "Savantvadi",
      "Savda",
      "Talegaon Dabhade",
      "Taloda",
      "Telhara",
      "Thane",
      "Tuljapur",
      "Tumsar",
      "Tasgaon",
      "Udgir",
      "Ulhasnagar",
      "Umarga",
      "Umarkhed",
      "Umred",
      "Uran",
      "Vaijapur",
      "Varangaon",
      "Vasind",
      "Virar",
      "Vite",
      "Vada",
      "Wai",
      "Wani",
      "Wardha",
      "Warora",
      "Warud",
      "Washim",
      "Yavatmal",
      "Yeola",
      "Yaval",
      "Arangaon",
      "Arvi",
    ],
    Manipur: [
      "Churachandpur",
      "Imphal",
      "Kakching",
      "Mayang Imphal",
      "Moirang",
      "Phek",
      "Thoubal",
    ],
    Meghalaya: ["Mankachar", "Nongstoin", "Shillong", "Tura"],
    Mizoram: ["Aizawl", "Kolasib", "Lunglei", "Saiha", "Serchhip"],
    NCT: [
      "Alipur",
      "Bawana",
      "Delhi",
      "Karol Bagh",
      "New Delhi",
      "Nangloi Jat",
    ],
    Nagaland: [
      "Dimapur",
      "Kohima",
      "Mokokchung",
      "Mon",
      "Tuensang",
      "Wokha",
      "Zunheboto",
    ],
    Odisha: [
      "Angul",
      "Bada Barabil",
      "Balasore",
      "Balangir",
      "Barbil",
      "Bargarh",
      "Barpali",
      "Bauda",
      "Bhadrakh",
      "Bhanjanagar",
      "Bhawanipatna",
      "Bhuban",
      "Bhubaneshwar",
      "Binka",
      "Birmitrapur",
      "Brahmapur",
      "Brajarajnagar",
      "Burla",
      "Balugaon",
      "Banapur",
      "Banki",
      "Basudebpur",
      "Chatrapur",
      "Cuttack",
      "Deogarh",
      "Dhenkanal",
      "Gunupur",
      "Hinjilikatu",
      "Hirakud",
      "Jagatsinghapur",
      "Jaleshwar",
      "Jatani",
      "Jeypore",
      "Jharsuguda",
      "Jajpur",
      "Kantabanji",
      "Kendraparha",
      "Kesinga",
      "Khurda",
      "Konarka",
      "Koraput",
      "Kuchaiburi",
      "Kamakhyanagar",
      "Malakanagiri",
      "Nayagarh",
      "Nimaparha",
      "Nowrangapur",
      "Nilgiri",
      "Padampur",
      "Paradip Garh",
      "Patnagarh",
      "Patamundai",
      "Phulabani",
      "Pipili",
      "Polasara",
      "Puri",
      "Remuna",
      "Sambalpur",
      "Sonepur",
      "Sorada",
      "Soro",
      "Sundargarh",
      "Titlagarh",
      "Talcher",
      "Asika",
      "Athagarh",
    ],
    Pondicherry: ["Karaikal", "Puducherry"],
    Punjab: [
      "Abohar",
      "Ahmadpur East",
      "Ahmadpur Sial",
      "Ajnala",
      "Alipur",
      "Amritsar",
      "Anandpur",
      "Attock City",
      "Baddomalhi",
      "Bahawalnagar",
      "Bahawalpur",
      "Banga",
      "Banur",
      "Barnala",
      "Basi",
      "Basirpur",
      "Batala",
      "Bhadaur",
      "Bhakkar",
      "Bhalwal",
      "Bhatinda",
      "Bhawana",
      "Bhawanigarh",
      "Bhera",
      "Bhogpur",
      "Bhopalwala",
      "Bhai Pheru",
      "Bhikhi",
      "Budhlada",
      "Bagha Purana",
      "Balachor",
      "Burewala",
      "Chak Two Hundred Forty-Nine TDA",
      "Chak Azam Saffo",
      "Chakwal",
      "Chawinda",
      "Chiniot",
      "Chishtian Mandi",
      "Choa Saidan Shah",
      "Chichawatni",
      "Chuhar Kana",
      "Chunian",
      "Darya Khan",
      "Daska",
      "Dasuya",
      "Dera Ghazi Khan",
      "Dhanaula",
      "Dhanot",
      "Dhariwal",
      "Dhuri",
      "Dijkot",
      "Dinga",
      "Doraha",
      "Dullewala",
      "Dunga Bunga",
      "Dunyapur",
      "Dajal",
      "Daud Khel",
      "Dinanagar",
      "Dipalpur",
      "Eminabad",
      "Faisalabad",
      "Faqirwali",
      "Faruka",
      "Faridkot",
      "Fatehgarh Churian",
      "Fazalpur",
      "Ferozepore",
      "Fort Abbas",
      "Fazilka",
      "Garh Maharaja",
      "Garhshankar",
      "Giddarbaha",
      "Gojra",
      "Gujranwala",
      "Gujrat",
      "Guru Har Sahai",
      "Gujar Khan",
      "Hadali",
      "Harnoli",
      "Haru Zbad",
      "Hasan Abdal",
      "Haveli",
      "Hazro",
      "Hujra",
      "Hafizabad",
      "Hasilpur",
      "Jagraon",
      "Jahanian Shah",
      "Jaito",
      "Jalandhar",
      "Jalalpur",
      "Jalalpur Pirwala",
      "Jalalabad",
      "Jand",
      "Jandiala",
      "Jaranwala",
      "Jatoi Shimali",
      "Jauharabad",
      "Jhang Sadr",
      "Jhawarian",
      "Jhelum",
      "Jhumra",
      "Jampur",
      "Kabirwala",
      "Kahuta",
      "Kallar Kahar",
      "Kalur Kot",
      "Kamar Mushani",
      "Kamoke",
      "Kamalia",
      "Kamir",
      "Kanganpur",
      "Kapurthala",
      "Karor",
      "Kartarpur",
      "Kasur",
      "Khairpur",
      "Khanna",
      "Kharar",
      "Khewra",
      "Khurrianwala",
      "Khushab",
      "Khangarh",
      "Khangah Dogran",
      "Khanpur",
      "Kharian",
      "Kiratpur",
      "Kohror Pakka",
      "Kot Addu",
      "Kot Ghulam Muhammad",
      "Kot Mumin",
      "Kot Radha Kishan",
      "Kot Samaba",
      "Kotkapura",
      "Kotli Loharan",
      "Kundian",
      "Kunjah",
      "Kahna",
      "Kaleke Mandi",
      "Kalabagh",
      "Kamra",
      "Ladhewala Waraich",
      "Lahore",
      "Laungowal",
      "Layyah",
      "Lodhran",
      "Ludhiana",
      "Lala Musa",
      "Lalian",
      "Mailsi",
      "Malakwal City",
      "Malakwal",
      "Malaut",
      "Mandi Bahauddin",
      "Mangla",
      "Maur",
      "Minchinabad",
      "Mitha Tiwana",
      "Mian Channun",
      "Mianwali",
      "Moga",
      "Mohali",
      "Morinda",
      "Mukerian",
      "Muktsar",
      "Multan",
      "Murree",
      "Muridke",
      "Mustafabad",
      "Muzaffargarh",
      "Machhiwara",
      "Maler Kotla",
      "Mamu Kanjan",
      "Mansa",
      "Mananwala",
      "Nakodar",
      "Nankana Sahib",
      "Naushahra Virkan",
      "Nawashahr",
      "Nabha",
      "Nangal Township",
      "Narang",
      "Narowal",
      "Okara",
      "Pasrur",
      "Pathankot",
      "Patiala",
      "Patti",
      "Pattoki",
      "Phagwara",
      "Phillaur",
      "Phalia",
      "Pind Dadan Khan",
      "Pindi Bhattian",
      "Pindi Gheb",
      "Pakpattan",
      "Pir Mahal",
      "Qadirpur Ran",
      "Qadian",
      "Rabwah",
      "Rawalpindi",
      "Renala Khurd",
      "Ropar",
      "Raikot",
      "Raiwind",
      "Raja Jang",
      "Rajanpur",
      "Rajpura",
      "Rampura",
      "Sahiwal",
      "Sambrial",
      "Samrala",
      "Sanaur",
      "Sangla Hill",
      "Sangrur",
      "Sardulgarh",
      "Sargodha",
      "Sarai Sidhu",
      "Sarai Alamgir",
      "Shahkot",
      "Shahr Sultan",
      "Shakargarr",
      "Sharqpur",
      "Sheikhupura",
      "Shujaabad",
      "Sialkot",
      "Sillanwali",
      "Sirhind",
      "Sodhra",
      "Sukheke Mandi",
      "Sultanpur",
      "Sunam",
      "Surkhpur",
      "Sadiqabad",
      "Sahiwal",
      "Talagang",
      "Talamba",
      "Talwandi Bhai",
      "Talwara",
      "Tarn Taran",
      "Taunsa",
      "Toba Tek Singh",
      "Tandlianwala",
      "Vihari",
      "Warburton",
      "Wazirabad",
      "Yazman",
      "Zafarwal",
      "Zira",
      "Zahir Pir",
      "Adampur",
      "Arifwala",
    ],
    Rajasthan: [
      "Ajmer",
      "Aklera",
      "Alwar",
      "Amet",
      "Anta",
      "Anupgarh",
      "Bagar",
      "Bari Sadri",
      "Basi",
      "Basni",
      "Baswa",
      "Bayana",
      "Begun",
      "Behror",
      "Beawar",
      "Bharatpur",
      "Bhasawar",
      "Bhindar",
      "Bhiwadi",
      "Bhadra",
      "Bhadasar",
      "Bhilwara",
      "Bhinmal",
      "Bilara",
      "Bissau",
      "Bali",
      "Balotra",
      "Bandikui",
      "Banswara",
      "Bari",
      "Barmer",
      "Baran",
      "Bikaner",
      "Bundi",
      "Chaksu",
      "Chhabra",
      "Chhoti Sadri",
      "Chhapar",
      "Chidawa",
      "Chittaurgarh",
      "Churu",
      "Dausa",
      "Deoli",
      "Deshnoke",
      "Devgarh",
      "Dhaulpur",
      "Didwana",
      "Dig",
      "Dungarpur",
      "Fatehpur",
      "Ganganagar",
      "Gangapur",
      "Gulabpura",
      "Hanumangarh",
      "Hindaun",
      "Jahazpur",
      "Jaipur",
      "Jaisalmer",
      "Jaitaran",
      "Jalor",
      "Jhunjhunun",
      "Jhalrapatan",
      "Jhalawar",
      "Jodhpur",
      "Karanpur",
      "Karauli",
      "Kekri",
      "Keshorai Patan",
      "Khandela",
      "Khetri",
      "Kishangarh",
      "Kota",
      "Kotputli",
      "Kuchera",
      "Kuchaman",
      "Kaman",
      "Kapren",
      "Kumher",
      "Lachhmangarh Sikar",
      "Losal",
      "Ladnun",
      "Lakheri",
      "Lalsot",
      "Mahwah",
      "Makrana",
      "Manoharpur",
      "Merta",
      "Malpura",
      "Mandal",
      "Mandalgarh",
      "Mangrol",
      "Mundwa",
      "Nagar",
      "Nainwa",
      "Napasar",
      "Naraina",
      "Nasirabad",
      "Nawalgarh",
      "Neem ka Thana",
      "Niwai",
      "Nohar",
      "Nokha",
      "Nadbai",
      "Nagaur",
      "Nathdwara",
      "Nawa",
      "Nimbahera",
      "Nimaj",
      "Padampur",
      "Parvatsar",
      "Phalodi",
      "Phulera",
      "Pilibangan",
      "Pilani",
      "Pindwara",
      "Pokaran",
      "Pratapgarh",
      "Pushkar",
      "Pali",
      "Pipar",
      "Raipur",
      "Ratangarh",
      "Raisinghnagar",
      "Rajaldesar",
      "Rajgarh",
      "Rajsamand",
      "Rajakhera",
      "Ramganj Mandi",
      "Ramgarh",
      "Rawatbhata",
      "Rawatsar",
      "Ringas",
      "Samdari",
      "Sangaria",
      "Sangod",
      "Sardarshahr",
      "Sarwar",
      "Sawai Madhopur",
      "Sheoganj",
      "Shahpura",
      "Sirohi",
      "Siwana",
      "Sojat",
      "Sri Dungargarh",
      "Sri Madhopur",
      "Suket",
      "Sunel",
      "Sadri",
      "Salumbar",
      "Sambhar",
      "Sanchor",
      "Sikar",
      "Sujangarh",
      "Surajgarh",
      "Suratgarh",
      "Takhatgarh",
      "Tijara",
      "Todabhim",
      "Todaraisingh",
      "Tonk",
      "Taranagar",
      "Udaipur",
      "Wer",
      "Abu",
      "Abu Road",
      "Asind",
    ],
    Sikkim: ["Gangtok"],
    "Tamil Nadu": [
      "Adirampattinam",
      "Alandur",
      "Ambasamudram",
      "Ambattur",
      "Ambur",
      "Anaimalai",
      "Annur",
      "Anthiyur",
      "Arakkonam",
      "Arantangi",
      "Arcot",
      "Ariyalur",
      "Arumuganeri",
      "Aruppukkottai",
      "Attur",
      "Avinashi",
      "Ayakudi",
      "Bhavani",
      "Bhuvanagiri",
      "Bodinayakkanur",
      "Chengalpattu",
      "Chengam",
      "Chennai",
      "Chennimalai",
      "Chetput",
      "Chettipalaiyam",
      "Cheyyar",
      "Chidambaram",
      "Chinna Salem",
      "Chinnamanur",
      "Coimbatore",
      "Colachel",
      "Cuddalore",
      "Cumbum",
      "Denkanikota",
      "Devakottai",
      "Dharapuram",
      "Dharmapuri",
      "Dindigul",
      "Erode",
      "Gingee",
      "Gobichettipalayam",
      "Gudalur",
      "Gudiyatham",
      "Gummidipundi",
      "Guduvancheri",
      "Harur",
      "Hosur",
      "Idappadi",
      "Injambakkam",
      "Irugur",
      "Jayamkondacholapuram",
      "Jolarpettai",
      "Kadayanallur",
      "Kalakkadu",
      "Kallakkurichchi",
      "Kallidaikurichchi",
      "Kalugumalai",
      "Kangayam",
      "Kanniyakumari",
      "Karur",
      "Kattivakkam",
      "Kayalpattinam",
      "Keelakarai",
      "Kodaikanal",
      "Koothanallur",
      "Kotagiri",
      "Kovilpatti",
      "Krishnagiri",
      "Kulittalai",
      "Kumbakonam",
      "Kurinjippadi",
      "Kuzhithurai",
      "Kanchipuram",
      "Karaikkudi",
      "Karamadai",
      "Katpadi",
      "Lalgudi",
      "Madambakkam",
      "Madipakkam",
      "Madukkarai",
      "Madukkur",
      "Madurai",
      "Madurantakam",
      "Mallasamudram",
      "Manali",
      "Manamadurai",
      "Manapparai",
      "Mandapam",
      "Mannargudi",
      "Marakkanam",
      "Mayiladuthurai",
      "Melur",
      "Mettupalayam",
      "Mettur",
      "Musiri",
      "Muttupet",
      "Minjur",
      "Nambiyur",
      "Nattam",
      "Neelankarai",
      "Nellikkuppam",
      "Nilakottai",
      "Nagappattinam",
      "Nagercoil",
      "Namagiripettai",
      "Namakkal",
      "Naravarikuppam",
      "Ooty",
      "Padmanabhapuram",
      "Palani",
      "Palladam",
      "Pallappatti",
      "Pallikondai",
      "Pallippatti",
      "Pallavaram",
      "Panruti",
      "Papanasam",
      "Paramagudi",
      "Pattukkottai",
      "Pennadam",
      "Pennagaram",
      "Perambalur",
      "Peranampattu",
      "Peravurani",
      "Periyakulam",
      "Periyanayakkanpalaiyam",
      "Perundurai",
      "Perungudi",
      "Pollachi",
      "Polur",
      "Ponneri",
      "Poonamalle",
      "Porur",
      "Pudukkottai",
      "Puliyangudi",
      "Punjai Puliyampatti",
      "Palakkodu",
      "Rajapalaiyam",
      "Ramanathapuram",
      "Rameswaram",
      "Rasipuram",
      "Saint Thomas Mount",
      "Salem",
      "Sathyamangalam",
      "Sattur",
      "Sholinghur",
      "Singanallur",
      "Sirumugai",
      "Sivaganga",
      "Sivagiri",
      "Sivakasi",
      "Srivaikuntam",
      "Srivilliputhur",
      "Sriperumbudur",
      "Sulur",
      "Sirkazhi",
      "Surandai",
      "Teni",
      "Thanjavur",
      "Tharangambadi",
      "Thenkasi",
      "Thiruthani",
      "Thiruvarur",
      "Tindivanam",
      "Tinnanur",
      "Tiruchchendur",
      "Tiruchengode",
      "Tiruchirappalli",
      "Tirukkoyilur",
      "Tirunelveli",
      "Tirupparangunram",
      "Tiruppur",
      "Tiruppuvanam",
      "Tiruttangal",
      "Tiruvallur",
      "Tiruvannamalai",
      "Tiruvottiyur",
      "Tisaiyanvilai",
      "Tondi",
      "Turaiyur",
      "Taramangalam",
      "Udankudi",
      "Udumalaippettai",
      "Usilampatti",
      "Uttamapalaiyam",
      "Uttiramerur",
      "V.S.K.Valasai (Dindigul-Dist.)",
      "Vadakku Valliyur",
      "Vadamadurai",
      "Valparai",
      "Vandavasi",
      "Vaniyambadi",
      "Vattalkundu",
      "Vedaraniyam",
      "Vellore",
      "Velur",
      "Vettaikkaranpudur",
      "Villupuram",
      "Viravanallur",
      "Virudunagar",
      "Vriddhachalam",
      "Vadippatti",
      "Vasudevanallur",
      "Walajapet",
      "Wellington",
      "Alangulam",
      "Alangayam",
      "Andippatti",
      "Arani",
      "Avadi",
    ],
    Telangana: [
      "Andol",
      "Asifabad",
      "Bellampalli",
      "Bhadrachalam",
      "Bhaisa",
      "Bhongir",
      "Bodhan",
      "Banswada",
      "Dasnapur",
      "Devarkonda",
      "Dornakal",
      "Farrukhnagar",
      "Gaddi Annaram",
      "Gadwal",
      "Ghatkesar",
      "Hyderabad",
      "Jagtial",
      "Jangaon",
      "Karimnagar",
      "Khammam",
      "Kodar",
      "Koratla",
      "Kottagudem",
      "Kyathampalle",
      "Kamareddi",
      "Kukatpalli",
      "Lal Bahadur Nagar",
      "Mahbubnagar",
      "Mahbubabad",
      "Malkajgiri",
      "Mancheral",
      "Mandamarri",
      "Manthani",
      "Manuguru",
      "Medak",
      "Mirialguda",
      "Nalgonda",
      "Nirmal",
      "Nizamabad",
      "Nagar Karnul",
      "Narayanpet",
      "Naspur",
      "Palwancha",
      "Patancheru",
      "Peddapalli",
      "Paloncha",
      "Quthbullapur",
      "Ramagundam",
      "Ramgundam",
      "Sadaseopet",
      "Sangareddi",
      "Sathupalli",
      "Secunderabad",
      "Serilingampalle",
      "Siddipet",
      "Singapur",
      "Sirsilla",
      "Sriramnagar",
      "Suriapet",
      "Tandur",
      "Uppal Kalan",
      "Vemalwada",
      "Vikarabad",
      "Wanparti",
      "Warangal",
      "Yellandu",
      "Zahirabad",
      "Adilabad",
    ],
    Tripura: [
      "Agartala",
      "Barjala",
      "Belonia",
      "Dharmanagar",
      "Kailashahar",
      "Khowai",
      "Udaipur",
    ],
    "Uttar Pradesh": [
      "Achhnera",
      "Afzalgarh",
      "Ahraura",
      "Ajodhya",
      "Akbarpur",
      "Allahabad",
      "Aliganj",
      "Aligarh",
      "Amroha",
      "Anupshahr",
      "Aonla",
      "Atarra",
      "Atrauli",
      "Auraiya",
      "Azamgarh",
      "Baberu",
      "Babrala",
      "Babina",
      "Bachhraon",
      "Baheri",
      "Bahjoi",
      "Bahraigh",
      "Balrampur",
      "Banat",
      "Baraut",
      "Bareilly",
      "Basti",
      "Behat",
      "Bela",
      "Bewar",
      "Bhadohi",
      "Bharthana",
      "Bharwari",
      "Bhinga",
      "Bhongaon",
      "Bidhuna",
      "Bijnor",
      "Bilgram",
      "Bilhaur",
      "Bilsanda",
      "Bilsi",
      "Bilthra",
      "Bilari",
      "Bindki",
      "Bisauli",
      "Biswan",
      "Budaun",
      "Budhana",
      "Bulandshahr",
      "Baghpat",
      "Bah",
      "Banda",
      "Bangarmau",
      "Bansdih",
      "Bansi",
      "Bilaspur",
      "Bisalpur",
      "Chandauli",
      "Chanduasi",
      "Charkhari",
      "Charthawal",
      "Chhaprauli",
      "Chharra",
      "Chhibramau",
      "Chhata",
      "Chillupar",
      "Chunar",
      "Chandpur",
      "Colonelganj",
      "Deoband",
      "Deoranian",
      "Deoria",
      "Dhanaura",
      "Dhaurahra",
      "Dhampur",
      "Dibai",
      "Dadri",
      "Dasna",
      "Dataganj",
      "Etawah",
      "Farrukhabad",
      "Faridpur",
      "Fatehganj West",
      "Fatehpur",
      "Fatehpur Sikri",
      "Fatehabad",
      "Fyzabad",
      "Firozabad",
      "Gajraula",
      "Gangoh",
      "Ganj Dundwara",
      "Garhmuktesar",
      "Ghazipur",
      "Ghosi",
      "Ghatampur",
      "Ghaziabad",
      "Gola Gokarannath",
      "Gonda City",
      "Gorakhpur",
      "Govardhan",
      "Greater Noida",
      "Gulaothi",
      "Gunnaur",
      "Gursahaiganj",
      "Gursarai",
      "Haldaur",
      "Hamirpur",
      "Handia",
      "Hardoi",
      "Hasanpur",
      "Hastinapur",
      "Hapur",
      "Hathras",
      "Indergarh",
      "Islamnagar",
      "Itimadpur",
      "Jagdishpur",
      "Jahangirabad",
      "Jais",
      "Jalesar",
      "Jalalpur",
      "Jalalabad",
      "Jalalabad",
      "Jalali",
      "Jarwal",
      "Jaswantnagar",
      "Jaunpur",
      "Jewar",
      "Jhinjhana",
      "Jhalu",
      "Jhansi",
      "Jhinjhak",
      "Jhusi",
      "Jalaun",
      "Jansath",
      "Kabrai",
      "Kachhwa",
      "Kaimganj",
      "Kairana",
      "Kakrala",
      "Kamalganj",
      "Kannauj",
      "Kanpur",
      "Karhal",
      "Kemri",
      "Khada",
      "Khair",
      "Khairabad",
      "Khalilabad",
      "Khatauli",
      "Khekra",
      "Kheri",
      "Khurja",
      "Khutar",
      "Kiraoli",
      "Kithor",
      "Konch",
      "Kopaganj",
      "Kosi",
      "Kulpahar",
      "Kunda",
      "Kundarkhi",
      "Kakori",
      "Kalpi",
      "Kandhla",
      "Kant",
      "Kanth",
      "Kasganj",
      "Kiratpur",
      "Lakhimpur",
      "Lalitpur",
      "Lar",
      "Loni",
      "Lucknow",
      "Laharpur",
      "Lalganj",
      "Lawar Khas",
      "Machhlishahr",
      "Maghar",
      "Mahmudabad",
      "Mahoba",
      "Maholi",
      "Maharaganj",
      "Mainpuri",
      "Malihabad",
      "Mandawar",
      "Maniar",
      "Manjhanpur",
      "Mariahu",
      "Mathura",
      "Mau",
      "Mau Aimma",
      "Maudaha",
      "Mawana",
      "Meerut",
      "Mehndawal",
      "Milak",
      "Mirzapur",
      "Misrikh",
      "Moradabad",
      "Mubarakpur",
      "Mughal Sarai",
      "Muhammadabad",
      "Muradnagar",
      "Muzaffarnagar",
      "Marahra",
      "Mirganj",
      "Miranpur",
      "Miranpur Katra",
      "Nagina",
      "Najibabad",
      "Nakur",
      "Nanauta",
      "Narauli",
      "Naraura",
      "Nautanwa",
      "Nawabganj",
      "Nichlaul",
      "Nihtaur",
      "Noida",
      "Nanpara",
      "Nurpur",
      "Obra",
      "Orai",
      "Pachperwa",
      "Padrauna",
      "Pahasu",
      "Palia Kalan",
      "Parichhatgarh",
      "Pawayan",
      "Phalauda",
      "Phaphund",
      "Phulpur",
      "Pihani",
      "Pilkhua",
      "Pinahat",
      "Pipraich",
      "Pukhrayan",
      "Purwa",
      "Pilibhit",
      "Puranpur",
      "Raebareli",
      "Rasra",
      "Renukut",
      "Reoti",
      "Richha",
      "Robertsganj",
      "Rura",
      "Ramnagar",
      "Rampur",
      "Ranipur",
      "Rath",
      "Raya",
      "Rudarpur",
      "Sadabad",
      "Safipur",
      "Sahaspur",
      "Sahaswan",
      "Saharanpur",
      "Sahawar",
      "Saidpur",
      "Sambhal",
      "Samthar",
      "Sandila",
      "Sarauli",
      "Sardhana",
      "Sarai Mir",
      "Sarai Akil",
      "Seohara",
      "Shamsabad",
      "Sherkot",
      "Shikohabad",
      "Shikarpur",
      "Shahganj",
      "Shahi",
      "Shahjanpur",
      "Shahpur",
      "Shahabad",
      "Shamli",
      "Shishgarh",
      "Sidhauli",
      "Sikandarpur",
      "Sikandarabad",
      "Sikandra Rao",
      "Sirsi",
      "Sirsaganj",
      "Sisauli",
      "Siswa Bazar",
      "Soron",
      "Sultanpur",
      "Surianwan",
      "Suar",
      "Sandi",
      "Sitapur",
      "Thakurdwara",
      "Thana Bhawan",
      "Tilhar",
      "Tulsipur",
      "Tajpur",
      "Tanda",
      "Tanda",
      "Tundla",
      "Ujhani",
      "Unnao",
      "Usehat",
      "Utraula",
      "Varanasi",
      "Vrindavan",
      "Wazirganj",
      "Zaidpur",
      "Zamania",
      "Agra",
      "Un",
    ],
    Uttarakhand: [
      "Almora",
      "Bazpur",
      "Clement Town",
      "Dehra Dun",
      "Haldwani",
      "Haridwar",
      "Jaspur",
      "Kashipur",
      "Khatima",
      "Kichha",
      "Kotdwara",
      "Laksar",
      "Manglaur",
      "Mussoorie",
      "Naini Tal",
      "Pauri",
      "Pithoragarh",
      "Rishikesh",
      "Roorkee",
      "Raipur",
      "Ramnagar",
      "Ranikhet",
      "Sitarganj",
      "Srinagar",
      "Tanakpur",
      "Tehri",
      "Uttarkashi",
    ],
    "West Bengal": [
      "Adra",
      "Aistala",
      "Arambagh",
      "Ashoknagar Kalyangarh",
      "Baduria",
      "Bagula",
      "Baharampur",
      "Bahula",
      "Baidyabati",
      "Baj Baj",
      "Balarampur",
      "Bangaon",
      "Bankra",
      "Baranagar",
      "Barddhaman",
      "Beldanga",
      "Bhadreswar",
      "Bhatpara",
      "Birpara",
      "Bishnupur",
      "Bolpur",
      "Baghdogra",
      "Bali",
      "Balurghat",
      "Bankura",
      "Bansbaria",
      "Baruipur",
      "Barakpur",
      "Barasat",
      "Canning",
      "Chakapara",
      "Chandannagar",
      "Chandrakona",
      "Chittaranjan",
      "Contai",
      "Dalkola",
      "Dam Dam",
      "Dhulagari",
      "Dhulian",
      "Dhupgari",
      "Diamond Harbour",
      "Dubrajpur",
      "Dumjor",
      "Durgapur",
      "Darjiling",
      "Dinhata",
      "Egra",
      "Farakka",
      "Fort Gloster",
      "Falakata",
      "Gangarampur",
      "Garui",
      "Ghatal",
      "Gobardanga",
      "Gosaba",
      "Goyerkata",
      "Guskhara",
      "Haldia",
      "Hugli",
      "Habra",
      "Halisahar",
      "Haora",
      "Hasimara",
      "Ingraj Bazar",
      "Islampur",
      "Jaigaon",
      "Jalpaiguri",
      "Jangipur",
      "Jaynagar-Majilpur",
      "Jhalida",
      "Jhargram",
      "Jamuria",
      "Kalyani",
      "Kenda",
      "Kharagpur",
      "Khardah",
      "Khatra",
      "Koch Bihar",
      "Kolkata",
      "Konnagar",
      "Krishnanagar",
      "Kultali",
      "Kulti",
      "Kalimpong",
      "Kaliyaganj",
      "Kalna",
      "Kamarhati",
      "Kanchrapara",
      "Kandi",
      "Karsiyang",
      "Katoya",
      "Lakhyabad",
      "Lalgola",
      "Madhyamgram",
      "Mahiari",
      "Mahishadal",
      "Mainaguri",
      "Medinipur",
      "Memari",
      "Monoharpur",
      "Murshidabad",
      "Matabhanga",
      "Nabagram",
      "Naihati",
      "Naksalbari",
      "Nalhati",
      "Nangi",
      "Navadwip",
      "Pandua",
      "Pujali",
      "Puruliya",
      "Panchla",
      "Panihati",
      "Raghunathpur",
      "Rampur Hat",
      "Rishra",
      "Raiganj",
      "Rajmahal",
      "Ramjibanpur",
      "Ranaghat",
      "Raniganj",
      "Sainthia",
      "Shiliguri",
      "Shrirampur",
      "Shyamnagar",
      "Shantipur",
      "Singur",
      "Siuri",
      "Sonamukhi",
      "Srirampur",
      "Sankrail",
      "Tamluk",
      "Tarakeswar",
      "Titagarh",
      "Tufanganj",
      "Taki",
      "Amlagora",
      "Amta",
      "Asansol",
    ],
  },
  "Sri Lanka": {
    Central: [
      "Apam",
      "Cape Coast",
      "Capiatá",
      "Colonia Mariano Roque Alonso",
      "Dambulla",
      "Dunkwa",
      "Elmina",
      "Fernando de la Mora",
      "Foso",
      "Gampola",
      "Hatton",
      "Itauguá",
      "Itá",
      "Kabwe",
      "Kandy",
      "Kapiri Mposhi",
      "Kasoa",
      "Lambaré",
      "Letlhakane",
      "Limpio",
      "Mahalapye",
      "Mumbwa",
      "Nemby",
      "Nuwara Eliya",
      "Palapye",
      "Saltpond",
      "San Antonio",
      "San Lorenzo",
      "Selebi-Phikwe",
      "Serowe",
      "Suva",
      "Swedru",
      "Tonota",
      "Villa Elisa",
      "Winneba",
    ],
    "Eastern Province": [
      "Abqaiq",
      "Abu Kabir",
      "Aketi",
      "Al Battaliyah",
      "Al Hufuf",
      "Al Ibrahimiyah",
      "Al Jubayl",
      "Al Khafji",
      "Al Mubarraz",
      "Al Munayzilah",
      "Al Qanayat",
      "Al Qayşumah",
      "Al Qatif",
      "Al Qurayn",
      "Ampara",
      "At Taraf",
      "Basoko",
      "Batticaloa",
      "Bilbays",
      "Bondo",
      "Bunia",
      "Buta",
      "Dammam",
      "Dhahran",
      "Diyarb Najm",
      "Eravur Town",
      "Faqus",
      "Hihya",
      "Isiro",
      "Kafr Şaqr",
      "Kalmunai",
      "Kenema",
      "Khobar",
      "Kibungo",
      "Kisangani",
      "Koidu",
      "Mashtul as Suq",
      "Rahimah",
      "Rwamagana",
      "Sayhat",
      "Segbwema",
      "Shanjeev Home",
      "Trincomalee",
      "Tarut",
      "Wamba",
      "Watsa",
      "Yangambi",
      "Zagazig",
      "Şafwá",
    ],
    "North Central": ["Anuradhapura"],
    "North Western": ["Chilaw", "Kurunegala", "Puttalam"],
    "Northern Province": [
      "Byumba",
      "Jaffna",
      "Kabala",
      "Lunsar",
      "Makeni",
      "Musanze",
      "Point Pedro",
      "Popondetta",
      "Port Loko",
      "Valvedditturai",
      "Vavuniya",
    ],
    Sabaragamuwa: ["Ratnapura"],
    Southern: [
      "Ambalangoda",
      "Bentota",
      "Choma",
      "Galle",
      "Kanye",
      "Livingstone",
      "Matara",
      "Mazabuka",
      "Monze",
      "Mosopa",
      "Siavonga",
      "Weligama",
    ],
    Uva: ["Badulla"],
    Western: [
      "Axim",
      "Battaramulla South",
      "Beruwala",
      "Bibiani",
      "Brikama",
      "Colombo",
      "Dehiwala-Mount Lavinia",
      "Galkissa",
      "Hanwella Ihala",
      "Hendala",
      "Homagama",
      "Ja Ela",
      "Kalutara",
      "Kandana",
      "Katunayaka",
      "Kelaniya",
      "Kolonnawa",
      "Kotikawatta",
      "Lautoka",
      "Maharagama",
      "Mongu",
      "Moratuwa",
      "Mount Lavinia",
      "Mulleriyawa",
      "Nadi",
      "Negombo",
      "Panadura",
      "Peliyagoda",
      "Pita Kotte",
      "Prestea",
      "Sekondi-Takoradi",
      "Sesheke",
      "Shama Junction",
      "Sri Jayewardenepura Kotte",
      "Sukuta",
      "Takoradi",
      "Tarkwa",
      "Wattala",
      "Welisara",
    ],
  },
  Bangladesh: {
    Barisal: [
      "Barisal",
      "Bhola",
      "Bhandaria",
      "Burhanuddin",
      "Gaurnadi",
      "Lalmohan",
      "Mathba",
      "Mehendiganj",
      "Nalchiti",
      "Pirojpur",
    ],
    Chittagong: [
      "Bandarban",
      "Chhagalnaiya",
      "Chittagong",
      "Comilla",
      "Cox’s Bazar",
      "Fatikchari",
      "Feni",
      "Hajiganj",
      "Khagrachhari",
      "Lakshmipur",
      "Laksham",
      "Manikchari",
      "Nabinagar",
      "Patiya",
      "Raojan",
      "Raipur",
      "Ramganj",
      "Sandwip",
      "Satkania",
      "Teknaf",
    ],
    Dhaka: [
      "Azimpur",
      "Bhairab Bazar",
      "Bajitpur",
      "Char Bhadrasan",
      "Dhaka",
      "Dohar",
      "Faridpur",
      "Gafargaon",
      "Jamalpur",
      "Kishorganj",
      "Mirzapur",
      "Muktagacha",
      "Mymensingh",
      "Madaripur",
      "Narsingdi",
      "Netrakona",
      "Nagarpur",
      "Narayanganj",
      "Paltan",
      "Palang",
      "Sakhipur",
      "Sarishabari",
      "Sherpur",
      "Tungi",
      "Tungipara",
      "Tangail",
    ],
    Khulna: [
      "Bheramara",
      "Bhatpara Abhaynagar",
      "Jessore",
      "Jhingergacha",
      "Kesabpur",
      "Khulna",
      "Kushtia",
      "Kalia",
      "Kaliganj",
      "Morrelgonj",
      "Narail",
      "Phultala",
      "Sarankhola",
      "Satkhira",
      "Uttar Char Fasson",
    ],
    "Rangpur Division": [
      "Badarganj",
      "Chilmari",
      "Dinajpur",
      "Lalmanirhat",
      "Nageswari",
      "Panchagarh",
      "Parbatipur",
      "Pirgaaj",
      "Rangpur",
      "Thakurgaon",
    ],
    Rajshahi: [
      "Bera",
      "Bogra",
      "Ishurdi",
      "Joypur Hat",
      "Nawabganj",
      "Pabna",
      "Par Naogaon",
      "Rajshahi",
      "Saidpur",
      "Shibganj",
      "Shahzadpur",
      "Sirajganj",
    ],
    Sylhet: ["Baniachang", "Chhatak", "Habiganj", "Maulavi Bazar", "Sylhet"],
  },
};
